// eslint-disable-next-line no-restricted-imports
import { Input as AntInput } from 'antd';
import styled, { css } from 'styled-components';
import theme from 'styled-theming';
import { prop, switchProp } from 'styled-tools';
import { BodyShort01, Text01 } from 'components/styles';

export type InputType = AntInput;
export interface GhostInput {
  ghost?: boolean;
}

export const InputBackgroundColor = theme('mode', {
  light: 'var(--gray-10)',
  gray: 'var(--white-100)',
});

export const InputFocus = css`
  box-shadow: none;
  border-bottom-color: transparent;
  outline-color: var(--primary-color);
  outline-offset: -2px;
`;

export const InputBorder = css`
  outline: 2px solid;
  outline-color: transparent;
  outline-offset: -2px;
  border: none;
  border-bottom: 1px solid var(--gray-50);
  border-radius: 0;
`;

export const HeightStyle = css`
  ${switchProp(prop('size', 'middle'), {
    small: 'var(--input-size-sm)',
    middle: 'var(--input-height-default)',
    large: 'var(--input-height-lg)',
  })}
`;

export const Height = css`
  height: ${HeightStyle};
`;

export const BackgroundColor = css`
  background-color: ${InputBackgroundColor};
`;

export const InputStyle = css`
  margin: 0;
  width: 100%;
  padding: 0 var(--spacing-05);
  ${InputBorder};
  ${BodyShort01};
  ${Text01};
  ${BackgroundColor};
  ${Height};
  &:focus {
    ${InputFocus};
  }
`;

export const Input = styled(AntInput)`
  ${InputStyle};

  &.ant-input-disabled {
    opacity: 0.5;
  }

  &.ant-input-affix-wrapper {
    &.ant-input-affix-wrapper-disabled {
      opacity: 0.5;
    }

    &:focus,
    &.ant-input-affix-wrapper-focused {
      ${InputFocus};
    }
    .ant-input {
      ${Text01};
      background-color: transparent;
    }
  }
`;
